import { UPDATE_ORDERS_WIDGET } from "./actionTypes"

export const updateOrdersWidget = data => {
  return {
    type: UPDATE_ORDERS_WIDGET,
    payload: data,
  }
}
